import { isBrowser } from './isBrowser';

export const getScrollPosition = (element?: HTMLElement) => {
  if (!isBrowser) return { x: 0, y: 0 };

  const useWindow = !element;

  return useWindow ? { x: window.scrollX, y: window.scrollY } : { x: element.scrollLeft, y: element.scrollTop };
};
